"use client";

import React, { useCallback } from "react";
import { X } from "lucide-react";
import { Badge } from "./badge";
import { Button } from "./button";

interface FilterChip {
  type: string;
  value: string;
  label: string;
}

interface SearchFilterChipsProps {
  chips: FilterChip[];
  onRemoveChip: (type: string, value: string) => void;
  onClearAll: () => void;
}

export function SearchFilterChips({
  chips,
  onRemoveChip,
  onClearAll,
}: SearchFilterChipsProps) {
  const handleRemove = useCallback(
    (type: string, value: string) => {
      onRemoveChip(type, value);
    },
    [onRemoveChip]
  );

  if (chips.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-wrap items-center gap-2 px-4 py-2 border-t border-gray-200 bg-gray-50">
      {chips.map((chip) => (
        <Badge
          key={`${chip.type}-${chip.value}`}
          variant="secondary"
          className="flex items-center gap-1 pl-2 pr-1 py-1"
        >
          <span className="text-xs">{chip.label}</span>
          <button type="button"
            onClick={() => handleRemove(chip.type, chip.value)}
            className="ml-1 hover:bg-gray-300 rounded p-0.5 transition-colors"
            aria-label={`Remove ${chip.label} filter`}
          >
            <X className="h-3 w-3" />
          </button>
        </Badge>
      ))}
      {chips.length > 0 && (
        <Button
          variant="ghost"
          size="sm"
          onClick={onClearAll}
          className="text-xs h-6 px-2 ml-auto"
        >
          Clear all
        </Button>
      )}
    </div>
  );
}
